module.exports = __webpack_public_path__ + "ath_game_web/img/release.d0a380c3.png";